(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["mood-equipment-script"] && !Shopify.designMode) return;
  try {
    (() => {const root=document.getElementById('mood-equipment');if(!root||root.dataset.ready)return;root.dataset.ready='true';const equipment=JSON.parse(root.querySelector('[data-equipment-data]').textContent);const machineModels=equipment.va||[];const cimbaliProducts=equipment.lc||[];let equipmentState=null;function machineRoundedAmount(a){return a===null?null:Math.ceil(a);}
function machineAmount(a){return a===null?'Price on request':'AED '+new Intl.NumberFormat('en-AE',{maximumFractionDigits:0}).format(machineRoundedAmount(a));}
function machineHref(p){return p.detailPath||'/collections/victoria-arduino-coffee-machines?model='+encodeURIComponent(p.slug)+'#machine-configurator';}
function machinePrice(p){return machineAmount(p.price/100);}
function machineConfiguration(p){return p.configurationSummary||[p.version,p.groups+' group',p.finish].filter(Boolean).join(' · ');}
function machineTaxIncluded(p,s){const c=s&&p.configurations?.find(r=>r.version===s.version&&r.groups===s.groups);return c?.taxByFinish?.[s.finish]??p.vatIncluded;}
function machineTaxLabel(p,s){return p.taxNote||(machineTaxIncluded(p,s)?'Machine price includes VAT.':'Indicative price · VAT to be confirmed.');}
function machineAllowedFinishes(p,version){return p.finishesByVersion?.[version]||p.finishes;}
function machineOptionAvailable(item,s){return (!item.versions||item.versions.includes(s.version))&&(!item.finishes||item.finishes.includes(s.finish));}
function machineTotals(p,s,extras=[]){
 const row=p.configurations.find(c=>c.version===s.version&&c.groups===s.groups),base=machineRoundedAmount(row?.prices[s.finish]??null);
 const requested=[...extras,...p.extras.filter(e=>e.selectedByFinish&&machineOptionAvailable(e,s))];
 const items=requested.filter((e,i)=>machineOptionAvailable(e,s)&&requested.findIndex(x=>x.name===e.name)===i).map(e=>({...e,amount:machineRoundedAmount(e.prices[String(s.groups)]??null)}));
 const extraAmount=items.reduce((sum,e)=>sum+(e.amount??0),0);
 const pending=items.filter(e=>e.amount===null),known=(base??0)+extraAmount;
 return {base,items,extras:extraAmount,known,total:base===null||pending.length?null:known,pending,
  label:base===null||pending.length?'Known subtotal':'Configuration total',
  display:base===null?(known?machineAmount(known)+' + machine on request':'Price on request'):machineAmount(known)+(pending.length?' + options on request':''),
  note:[base===null?'Machine price to be confirmed.':machineTaxLabel(p,s),items.length?'Options VAT to be confirmed.':'',pending.length?'Unpriced selections are excluded from the subtotal.':''].filter(Boolean).join(' ')};
}
function machineDetailQuote(p,s,amount,extras=[]){
 const total=machineTotals(p,s,extras);
 const lines=['Hello Mood Espresso,','','I would like a quotation for:','Victoria Arduino '+p.name,...(s.version?['Version: '+s.version]:[]),'Groups: '+s.groups,'Finish: '+s.finish,'Machine price: '+machineAmount(amount),amount===null?'Please confirm this configuration price.':machineTaxLabel(p,s)];
 const row=p.configurations.find(c=>c.version===s.version&&c.groups===s.groups);if(row?.orderCode)lines.push('Order code: '+row.orderCode);
 if(total.items.length){lines.push('','Requested additional options:');total.items.forEach(e=>{lines.push(e.name+': '+machineAmount(e.amount));const code=e.codeByGroups?.[String(s.groups)]||e.code;if(code)lines.push('Reference: '+code);if(e.notes)lines.push(e.notes);});lines.push('Extras priced separately. VAT treatment to be confirmed.');}
 lines.push('',total.label+': '+total.display,total.note);
 lines.push('','Please confirm availability, the final quotation, delivery and installation details.','','Thank you.');
 return 'mailto:cs@bestaromaticohits.com?subject='+encodeURIComponent('Quotation request: Victoria Arduino '+p.name)+'&body='+encodeURIComponent(lines.join('\n'));
}
function machineQuoteHref(p){return machineDetailQuote(p,{version:p.version,groups:p.groups,finish:p.finish},p.price/100);}

function machineSelection(p,s={}){return {version:s.version||p.version,groups:Number(s.groups||p.groups),finish:s.finish||p.finish};}
function machineViews(p,selection={}){
 const s=machineSelection(p,selection),media=p.media||[];
 if(media.length){
  const noGroupPhoto=!media.some(v=>v.groups===s.groups&&(!v.versions||v.versions.includes(s.version)));
  const rank=v=>(v.groups===s.groups?150:!v.groups?20:0)+(v.finish===s.finish?30:0)+(!v.versions||v.versions.includes(s.version)?70:0)+(v.kind==='product'?10:0)+(/front/i.test(v.label)?5:0)+(noGroupPhoto&&v.groups&&/front view/i.test(v.label)?100:0)-(v.priority||0);
  return [...media.map((v,i)=>({v,i})).sort((a,b)=>rank(b.v)-rank(a.v)||a.i-b.i).map(x=>x.v).filter((v,i,a)=>a.findIndex(x=>x.src===v.src)===i),...(p.lifestyleMedia||[])];
 }
 return [{src:p.asset,width:p.photoWidth,height:p.photoHeight,box:p.photo,label:'Product reference',finish:null,reference:true}];
}
function machinePrimaryViewIndex(p,s,views,intent='groups'){
 if(intent==='finish'){
  let i=views.findIndex(v=>v.finish===s.finish&&v.groups===s.groups&&(!v.versions||v.versions.includes(s.version)));
  if(i<0)i=views.findIndex(v=>v.finish===s.finish&&!v.groups&&(!v.versions||v.versions.includes(s.version)));
  if(i>=0)return i;
 }
 return 0;
}
function machinePhotoEscape(value){return String(value??'').replace(/[&<>"']/g,c=>({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[c]));}
function machinePhotoHTML(view,alt='',loading='lazy',className=''){
 const e=machinePhotoEscape;
 if(view.visibleBounds){const[x,y,r,b]=view.visibleBounds,w=r-x,h=b-y;return `<span class="reference-photo manufacturer-photo manufacturer-cutout ${e(className)}" style="--photo-ratio:${w}/${h};--photo-width-ratio:${w/h};--photo-width:${view.width/w*100}%;--photo-left:${-x/w*100}%;--photo-top:${-y/h*100}%"><img src="${e(view.src)}" width="${view.width}" height="${view.height}" alt="${e(alt)}" loading="${loading}" decoding="async"></span>`;}
 if(view.box){const[x,y,w,h]=view.box;return `<span class="reference-photo ${e(className)}" style="--photo-ratio:${w}/${h};--photo-width-ratio:${w/h};--photo-width:${view.width/w*100}%;--photo-left:${-x/w*100}%;--photo-top:${-y/h*100}%"><img src="${e(view.src)}" width="${view.width}" height="${view.height}" alt="${e(alt)}" loading="${loading}" decoding="async"></span>`;}
 return `<span class="reference-photo manufacturer-photo ${view.editorial?'editorial-photo ':''}${view.lightBackground?'studio-light ':''}${e(className)}" style="--photo-ratio:${view.width}/${view.height};--photo-width-ratio:${view.width/view.height};--photo-width:100%;--photo-left:0%;--photo-top:0%"><img src="${e(view.src)}" width="${view.width}" height="${view.height}" alt="${e(alt)}" loading="${loading}" decoding="async"></span>`;
}
function machineViewLabel(view){return [view.finish,view.label,view.groups?view.groups+' group':''].filter(Boolean).join(' · ');}
function machineViewNote(p,selection,view){
 if(view.editorial)return 'Lifestyle image; selected configuration may differ.';
 const s=machineSelection(p,selection),notes=[];
 if(p.missingGroupPhotos?.includes(s.groups))notes.push(`${s.groups} group photograph not available. Reference view shown.`);
 if(view.reference)notes.push('Reference image. An official photograph of this configuration is not available.');
 else if(view.finish&&view.finish!==s.finish)notes.push(`${s.finish}: photograph not available. ${view.finish} finish shown.`);
 else if(!view.finish)notes.push(p.media?.some(v=>v.finish===s.finish)?'Product photograph; finish may differ.':`${s.finish}: photograph not available. Product reference shown.`);
 if(view.groups&&view.groups!==s.groups)notes.push(`${view.groups} group machine shown; ${s.groups} group selected.`);
 if(!view.groups&&s.groups>1)notes.push('Group count is not shown in this view.');
 if(view.versions&&!view.versions.includes(s.version))notes.push(`${view.versions.join(' / ')} reference shown; ${s.version} selected.`);
 if(/custom/i.test(s.finish))notes.push('Your custom colour will be confirmed with our team.');
 return notes.join(' ');
}

(function (root) {
  'use strict';

  const retail = cents => cents === null ? null : Math.ceil(cents / 500) * 500;
  const variant = (p, s) => p.variants.find(v => v.id === s.variantId) || p.variants[0];
  const colors = (p, s) => variant(p, s).colors || p.colors || [];
  function diameters(p, s) {
    const v = variant(p, s);
    return v.coffee_group_diameter_mm ? [v.coffee_group_diameter_mm] : (p.specifications?.coffee_group_diameter_choices_mm || []);
  }
  function available(p, s, o) {
    const v = variant(p, s);
    if (!Object.hasOwn(o.prices_cents, v.id)) return false;
    const diameter = Number(s.diameter);
    if (p.id === 's30-cp10') {
      if (o.name === 'Third integrated grinder' && diameter !== 50) return false;
      if (o.name === 'Motorized spout' && diameter !== 44) return false;
    }
    if (p.id === 's20-cp10' && o.name === 'TurboSteam Cold Touch' && diameter !== 50) return false;
    if (/2 grinders|2 integrated grinders/.test(o.condition || '') && v.integrated_grinders !== 2) return false;
    return true;
  }
  function conflict(p, a, b) {
    if (a.id === b.id) return false;
    if (a.exclusive_group && a.exclusive_group === b.exclusive_group) return true;
    if (a.excludes?.includes(b.name) || b.excludes?.includes(a.name)) return true;
    return p.id === 's30-cp10' && [a.name, b.name].includes('Third integrated grinder') && [a.name, b.name].includes('TurboSteam Cold Touch');
  }
  function normalize(p, s) {
    s.variantId = variant(p, s).id;
    const c = colors(p, s), d = diameters(p, s);
    if (!c.includes(s.finish)) s.finish = c[0] || '';
    if (!d.includes(Number(s.diameter))) s.diameter = d[0] || null;
    s.selected = [...new Set(s.selected || [])].filter(id => p.options.some(o => o.id === id && available(p, s, o)));

    let previous;
    do {
      previous = s.selected.length;
      s.selected = s.selected.filter(id => {
        const o = p.options.find(x => x.id === id);
        return (o.requires || []).every(name => p.options.some(x => x.name === name && s.selected.includes(x.id)));
      });
    } while (previous !== s.selected.length);
    return s;
  }
  function toggle(p, s, id, checked) {
    const option = p.options.find(o => o.id === id);
    if (!option || !available(p, s, option)) return;
    if (checked) {
      const additions = [], seen = new Set();
      function include(o) {
        if (!o || !available(p, s, o)) return false;
        if (seen.has(o.id)) return true;
        seen.add(o.id);
        if (!(o.requires || []).every(name => include(p.options.find(x => x.name === name)))) return false;
        additions.push(o); return true;
      }
      if (!include(option)) return;
      for (const o of additions) {
        s.selected = s.selected.filter(selected => selected !== o.id && !conflict(p, o, p.options.find(x => x.id === selected)));
        s.selected.push(o.id);
      }
    } else s.selected = s.selected.filter(selected => selected !== id);
    normalize(p, s);
  }
  function total(p, s) {
    const v = variant(p, s);
    const required = v.price_includes_required_water_tank ? 0 : (p.mandatory_accessories || []).reduce((n, o) => n + retail(o.price_cents) * (o.quantity || 1), 0);
    const selected = p.options.filter(o => s.selected.includes(o.id) && available(p, s, o));
    const unknown = selected.filter(o => o.prices_cents[v.id] === null);
    const extras = selected.reduce((n, o) => n + (retail(o.prices_cents[v.id]) || 0), 0);
    const base = retail(v.price_cents);
    return {base, required, extras, cents:base + required + extras, unknown, selected};
  }
  const api = {retail, variant, colors, diameters, available, conflict, normalize, toggle, total};
  if (typeof module !== 'undefined' && module.exports) module.exports = api;
  else root.CimbaliPricing = api;
})(typeof globalThis !== 'undefined' ? globalThis : this);

function cimbaliCategory(p){return p.category==='traditional'?'Traditional espresso':'Fully automatic';}
function cimbaliHref(p){return '/collections/lacimbali-coffee-machines'+p.id+'/';}
function cimbaliDefault(p){const v=p.variants.reduce((a,b)=>a.price_cents<=b.price_cents?a:b);return CimbaliPricing.normalize(p,{variantId:v.id,finish:'',diameter:null,selected:[]});}
function cimbaliMoney(cents){return cents===null?'Price on request':machineAmount(cents/100);}
function cimbaliPhoto(p,s){return CimbaliPricing.variant(p,s).imageInfo||p.imageInfo;}
function cimbaliPhotoHTML(p,s,loading='lazy'){
 const v=cimbaliPhoto(p,s);
 return machinePhotoHTML({...v,lightBackground:true},'La Cimbali '+p.family+' · catalogue photograph',loading,'cimbali-photo');
}
function cimbaliSelection(p,s){const v=CimbaliPricing.variant(p,s);return [v.name,s.finish||'Catalogue standard finish',s.diameter?'D'+s.diameter:null].filter(Boolean).join(' · ');}
function cimbaliTaxNote(){return root.dataset.cimbaliPriceNote || 'Prices revised 6 October 2026. Availability and VAT treatment to be confirmed.';}
function cimbaliTotalLabel(t){return t.unknown.length?'Priced subtotal':'Configuration total';}
function cimbaliOptionNote(p,o){return p.id==='s15-cs21'&&o.name==='Solubles hopper extension up to 2.9 kg, 1 piece'?'Compatibility with this model requires supplier confirmation.':'';}
function cimbaliQuote(p,s){
 const t=CimbaliPricing.total(p,s),v=CimbaliPricing.variant(p,s);
 const lines=['Hello Mood Espresso,','','I would like a quotation for:','La Cimbali '+p.family,'Configuration: '+v.name,
 'Finish: '+(s.finish||'Catalogue standard'),...(s.diameter?['Coffee group diameter: '+s.diameter+' mm']:[]),
 'Machine price: '+cimbaliMoney(t.base),
 ...p.mandatory_accessories.map(o=>'Required: '+o.name+' × '+(o.quantity||1)+': '+(o.included_in_machine_price ? (root.dataset.cimbaliIncludedTank || 'Included in machine price') : cimbaliMoney(CimbaliPricing.retail(o.price_cents)*(o.quantity||1)))),
 ...t.selected.map(o=>'Option: '+o.name+': '+cimbaliMoney(o.prices_cents[v.id])+(o.code?' · Reference '+o.code:'')+(cimbaliOptionNote(p,o)?' · '+cimbaliOptionNote(p,o):'')),
 '',cimbaliTotalLabel(t)+': '+cimbaliMoney(t.cents),
 ...(t.unknown.length?['Unpriced options are excluded from this subtotal and require a quotation.']:[]),
 ...(p.legacy?['Legacy catalogue model. Please confirm availability.']:[]),
 'Source: LaCimbali PE 2024 EUR, page '+p.page+'.',cimbaliTaxNote(),
 'Please confirm availability, delivery, installation and the final quotation.','','Thank you.'];
 return 'mailto:cs@bestaromaticohits.com?subject='+encodeURIComponent('Quotation request: La Cimbali '+p.family)+'&body='+encodeURIComponent(lines.join('\n'));
}
function cimbaliSpecs(p,s){
 const v=CimbaliPricing.variant(p,s),spec={...p.specifications,...v},rows=[];
 const add=(label,value,suffix='')=>{if(value!==null&&value!==undefined&&value!=='')rows.push([label,(Array.isArray(value)?value.join('–'):String(value))+suffix]);};
 const dimensions=spec.dimensions_mm;
 if(dimensions)add('Dimensions W × D × H',Array.isArray(dimensions)?dimensions.join(' × '):['width','depth','height'].map(k=>dimensions[k]).join(' × '),' mm');
 add('Groups',spec.groups);add('Controls',spec.controls);add('Operation',spec.operation);add('Weight',spec.weight_kg,' kg');
 if(p.recommended_cups_per_day)add('Recommended daily output','Up to '+p.recommended_cups_per_day+' cups');
 if(spec.integrated_grinders)add('Integrated grinders',spec.integrated_grinders+(s.selected.some(id=>p.options.find(o=>o.id===id)?.name==='Third integrated grinder')?1:0));
 if(s.diameter)add('Coffee group diameter',s.diameter,' mm');
 add('Spout',s.selected.some(id=>p.options.find(o=>o.id===id)?.name==='Motorized spout')?'Motorized':spec.spout);
 add('Service boiler',spec.boiler_capacity_litres,' L');
 if(spec.boilers_l)add('Boilers',spec.boilers_l.join(' + '),' L');
 add('Independent coffee boilers',spec.independent_coffee_boilers);
 add('Coffee boiler per group',spec.coffee_boiler_capacity_cc_each,' cc');add('Coffee boiler',spec.coffee_boiler_capacity_litres,' L');
 add('Water tank',spec.water_tank_l||spec.water_tank_capacity_l,' L');
 add('Power',spec.power_w,' W');add('Power · 50 Hz',spec.power_w_50hz,' W');add('Power · 60 Hz',spec.power_w_60hz,' W');add('Power · alternate 220–240 V',spec.alternate_220_240v_power_w,' W');
 for(const [key,label] of [['voltage','Voltage'],['voltage_as_printed','Voltage / frequency'],['coffee_hoppers_kg','Coffee hoppers (kg)'],['soluble_hoppers_kg','Soluble hoppers (kg)'],['touchscreen_drink_selections','Drink selections'],['preset_recipes','Preset recipes'],['grounds_capacity','Grounds capacity'],['drip_tray_l','Drip tray (L)'],['current_a','Current (A)'],['water_pump','Water pump'],['steam_wands','Steam wands']]){
   if(p.id==='s30-cp10'&&key==='soluble_hoppers_kg')continue;
   let value=spec[key];
   if(key==='coffee_hoppers_kg'&&Array.isArray(value)){
     if(v.integrated_grinders===1&&value.length>1)continue;
     value=value.join(' + ');
   }else if(key==='soluble_hoppers_kg'&&value&&typeof value==='object'){
     value=Array.isArray(value)?value.join(' + '):Object.entries(value).map(([name,capacity])=>name.replaceAll('_',' ').replace(/^./,c=>c.toUpperCase())+': '+capacity).join(' · ');
   }else if(key.startsWith('voltage')&&Array.isArray(value))value=value.join(' / ');
   add(label,value);
 }
 return rows;
}
function cimbaliFeatures(p){return p.features.filter(f=>!(p.id==='m26-se'&&/wi.?fi/i.test(f))).map(f=>f.replace(' per model-specific table',''));}

const machineLineKey=parts=>'machine:'+encodeURIComponent(JSON.stringify(parts)).replaceAll("'",'%27');
function victoriaCartKey(p,s,extras=[]){return machineLineKey(['va',p.slug,s.version,Number(s.groups),s.finish,machineTotals(p,s,extras).items.map(o=>o.name).sort()]);}
function cimbaliCartKey(p,s){return machineLineKey(['lc',p.id,s.variantId,s.finish,Number(s.diameter)||null,[...s.selected].sort()]);}
function equipmentButtons(pending){for(const b of root.querySelectorAll('[id$="add-to-cart"]'))b.textContent=pending?'Request this configuration':'Add to cart';}
function equipmentStatus(message,error=false,target){const el=target||root.querySelector('.equipment-cart-status');el.textContent=message;el.classList.toggle('equipment-error',error);return el;}
function equipmentQuote(href){const el=equipmentStatus('This selection includes a price on request. Send the complete configuration to our team for a quotation.');const a=document.createElement('a');a.href=href;a.textContent='Request quotation';a.className='machine-button light';el.append(' ',a);el.scrollIntoView({behavior:'smooth',block:'center'});a.focus();}
async function equipmentCart(items,expected,statusTarget){
 if(root.dataset.cartBusy==='true')return;root.dataset.cartBusy='true';
 const status=(message,error=false)=>equipmentStatus(message,error,statusTarget);
 const buttons=[...root.querySelectorAll('[id$="add-to-cart"],.grinder-add')];const disabled=buttons.map(b=>b.disabled);buttons.forEach(b=>b.disabled=true);
 const base=window.Shopify?.routes?.root||'/';status('Checking your configuration…');
 try{
  const handles=[...new Set(items.map(i=>i.handle))];
  const catalogs=await Promise.all(handles.map(async h=>{const r=await fetch(base+'products/'+encodeURIComponent(h)+'.js');if(!r.ok)throw Error('Unable to verify this configuration. Please try again.');return [h,await r.json()];}));
  const prices=new Map(catalogs);let actual=0;
  for(const i of items){const v=prices.get(i.handle).variants.find(v=>String(v.id)===String(i.id));if(!v||!v.available)throw Error('A selected item is currently unavailable. Please contact us to confirm availability.');if(v.price!==i.price)throw Error('A selected item price has changed. Please contact us to confirm the latest configuration price.');actual+=v.price*i.quantity;}
  if(actual!==expected)throw Error('We could not verify the configuration total. Please contact us for a quotation.');
  await window.MoodCart.add({items:items.map(({id,quantity,properties})=>({id,quantity,properties}))},root);
  status('');
 }catch(error){status(error.message||'Unable to add this configuration. Please try again.',true).scrollIntoView({behavior:'smooth',block:'center'});}
 finally{buttons.forEach((b,i)=>b.disabled=disabled[i]);delete root.dataset.cartBusy;}
}
async function addMachineToCart(key){
 try{
  const a=JSON.parse(decodeURIComponent(key.slice(8)));let model,selection,total,baseKey,extras,quote,name,configuration;
  if(a[0]==='va'){
   model=machineModels.find(p=>p.slug===a[1]);selection={version:a[2],groups:a[3],finish:a[4]};if(!model)return;
   extras=a[5].map(n=>[...model.extras,...model.accessories].find(o=>o.name===n));if(extras.some(o=>!o))return;
   const t=machineTotals(model,selection,extras);total=t.total===null?null:t.total*100;
   quote=machineDetailQuote(model,selection,t.base,extras);name='Victoria Arduino '+model.name;configuration=[selection.version,selection.groups+' group',selection.finish].join(' · ');
   baseKey='va:'+model.id+':'+selection.version+':'+selection.groups+':'+selection.finish;
   extras=t.items.filter(o=>!o.selectedByFinish).map(o=>({name:o.name,price:o.amount===null?null:o.amount*100,key:'va:'+model.id+':'+[...model.extras,...model.accessories].findIndex(x=>x.name===o.name)+':'+o.amount*100}));
  }else if(a[0]==='lc'){
   model=cimbaliProducts.find(p=>p.id===a[1]);if(!model)return;
   selection=CimbaliPricing.normalize(model,{variantId:a[2],finish:a[3],diameter:a[4],selected:a[5]});const t=CimbaliPricing.total(model,selection);total=t.unknown.length?null:t.cents;
   quote=cimbaliQuote(model,selection);name='La Cimbali '+model.family;configuration=cimbaliSelection(model,selection);
   baseKey='lc:'+model.id+':'+selection.variantId+':'+selection.finish+':'+(selection.diameter||'');
   extras=t.selected.map(o=>{const price=CimbaliPricing.retail(o.prices_cents[selection.variantId]);return {name:o.name,price,key:'lc:'+model.id+':'+model.options.findIndex(x=>x.id===o.id)+':'+price};});
  }else return;
  if(total===null){equipmentQuote(quote);return;}
  const variant=equipment.baseVariants[baseKey];if(!variant)throw Error('This configuration needs confirmation. Please contact us for a quotation.');
  const group=Date.now().toString(36)+'-'+Math.random().toString(36).slice(2,7);
  const properties={'Configuration':configuration,'Selected options':extras.map(o=>o.name).join(', ')||'None','_Equipment configuration':group};
  const items=[{...variant,quantity:1,properties}];
  for(const extra of extras){if(extra.price===0)continue;const option=equipment.optionVariants[extra.key];if(!option)throw Error('An option needs confirmation. Please contact us for a quotation.');items.push({...option,quantity:1,properties:{'For machine':name,'Configuration':configuration,'_Equipment configuration':group}});}
  const quantity=Number(root.querySelector('[data-machine-quantity]')?.value||1);
  if(!Number.isInteger(quantity)||quantity<1||quantity>99)throw Error('Enter a quantity from 1 to 99.');
  items.forEach(item=>item.quantity*=quantity);
  await equipmentCart(items,total*quantity);
 }catch(e){equipmentStatus(e.message||'Please review the configuration and try again.',true);}
}

'use strict';
(() => {
  const page=document.querySelector('[data-machine-detail]');
  if(!page)return;
  const model=machineModels.find(p=>p.slug===page.dataset.machineDetail);
  if(!model)return;
  const $=id=>document.getElementById(id);
  const fields=['version','groups','finish'];if(equipment.initial?.version)for(const key of fields)if($('md-'+key))$('md-'+key).value=equipment.initial[key];
  const chosen=new Set();
  const options=[...model.extras,...model.accessories];
  let gallery=[],activeView=0,photoKey='';
  const queryFinish=new URLSearchParams(location.search).get('finish');
  if(machineAllowedFinishes(model,$('md-version').value).includes(queryFinish))$('md-finish').value=queryFinish;
  function showView(index){
    activeView=index;const view=gallery[index];if(!view)return;
    $('md-photo').innerHTML=machinePhotoHTML(view,model.name+' · '+machineViewLabel(view),'eager');
    $('md-photo-label').textContent=machineViewLabel(view);
    $('md-photo-note').textContent=machineViewNote(model,selection(),view);
    $('md-full-photo').href=view.originalUrl||view.src;$('md-full-photo').hidden=!!view.reference;
    $('md-photo-source').href=view.sourcePage||'#';$('md-photo-source').hidden=!view.sourcePage;
    document.querySelectorAll('[data-detail-view]').forEach(b=>b.setAttribute('aria-pressed',String(Number(b.dataset.detailView)===index)));
  }
  function refreshPhotos(s,intent){
    const key=[s.version,s.groups,s.finish].join('|');if(key===photoKey)return;photoKey=key;
    gallery=machineViews(model,s);
    $('md-gallery').innerHTML=gallery.map((view,i)=>`<button type="button" data-detail-view="${i}" aria-label="Show ${machinePhotoEscape(machineViewLabel(view))}" aria-pressed="${i===0}">${machinePhotoHTML(view,'')}<span>${machinePhotoEscape(view.label)}</span></button>`).join('');
    document.querySelectorAll('[data-detail-view]').forEach(button=>button.addEventListener('click',()=>showView(Number(button.dataset.detailView))));
    showView(machinePrimaryViewIndex(model,s,gallery,intent));
  }
  function selection(){return {version:$('md-version').value,groups:Number($('md-groups').value),finish:$('md-finish').value};}
  function refresh(intent){
    const s=selection();
    refreshPhotos(s,intent);
    const row=model.configurations.find(c=>c.version===s.version&&c.groups===s.groups);
    const amount=row?.prices[s.finish]??null;equipmentState={brand:'va',model,selection:s,extras:[...chosen].map(i=>options[i])};
    $('md-selection').textContent=[s.version,s.groups+' group',s.finish].join(' · ');
    document.querySelectorAll('[data-machine-extra]').forEach(input=>{
      const item=options[Number(input.dataset.machineExtra)];
      const available=machineOptionAvailable(item,s);
      const index=Number(input.dataset.machineExtra);
      if(item.selectedByFinish){input.checked=available;if(available)chosen.add(index);else chosen.delete(index);}
      input.disabled=!available||!!item.selectedByFinish;
      if(!available){input.checked=false;chosen.delete(Number(input.dataset.machineExtra));}
      const cost=item.prices[String(s.groups)]??null;
      input.closest('label').querySelector('[data-extra-price]').textContent=item.selectedByFinish
        ?machineAmount(cost)+(available?' · Selected with finish':' · Choose this option under Finish')
        :available?machineAmount(cost):'Not available for this selection';
    });
    const extras=[...chosen].map(i=>options[i]);
    const total=machineTotals(model,s,extras);equipmentState={brand:'va',model,selection:s,extras};equipmentButtons(total.total===null);
    $('md-price').textContent=total.display;
    $('md-total-label').textContent=total.label;
    $('md-base-price').textContent=machineAmount(total.base);
    $('md-extras-price').textContent=machineAmount(total.extras)+(total.pending.length?' + on request':'');
    $('md-vat').textContent=total.note;
    $('md-options-total').textContent=total.display;
    $('md-options-total-label').textContent=total.label;
    $('md-options-total-note').textContent=total.note;
    $('md-selected-count').textContent=extras.length+' selected';
    $('md-bottom-total').textContent=total.label+': '+total.display;
    $('md-selected-options').innerHTML=total.items.map(e=>`<li><span>${machinePhotoEscape(e.name)}</span><span>${machineAmount(e.amount)}</span></li>`).join('');
    $('md-selected-options').hidden=!extras.length;
  }
  fields.forEach(key=>$('md-'+key).addEventListener('change',()=>{
    if(key==='version'){
      const finish=$('md-finish');const current=finish.value;
      const allowed=machineAllowedFinishes(model,$('md-version').value);
      finish.replaceChildren(...allowed.map(value=>{const option=document.createElement('option');option.value=value;option.textContent=value;return option;}));
      finish.value=allowed.includes(current)?current:allowed[0];
    }
    refresh(key);
  }));
  document.querySelectorAll('[data-machine-extra]').forEach(input=>input.addEventListener('change',()=>{
    const i=Number(input.dataset.machineExtra);
    if(input.checked){
      if(options[i].exclusiveGroup)document.querySelectorAll('[data-machine-extra]').forEach(other=>{
        const j=Number(other.dataset.machineExtra);
        if(j!==i&&options[j].exclusiveGroup===options[i].exclusiveGroup){other.checked=false;chosen.delete(j);}
      });
      chosen.add(i);
    }else chosen.delete(i);
    refresh();
  }));
  for(const id of ['md-add-to-cart','md-options-add-to-cart','md-bottom-add-to-cart'])$(id).addEventListener('click',()=>addMachineToCart(victoriaCartKey(model,selection(),[...chosen].map(i=>options[i]))));
  refresh();
})();

'use strict';
(() => {
 const page=document.querySelector('[data-cimbali-detail]');if(!page)return;
 const p=cimbaliProducts.find(p=>p.id===page.dataset.cimbaliDetail);if(!p)return;
 const P=CimbaliPricing,$=id=>document.getElementById(id),esc=machinePhotoEscape;
 const state=cimbaliDefault(p),query=new URLSearchParams(location.search);if(equipment.initial?.variantId)Object.assign(state,equipment.initial);
 if(p.variants.some(v=>v.id===query.get('variant')))state.variantId=query.get('variant');
 if(query.has('finish'))state.finish=query.get('finish');
 if(query.has('diameter'))state.diameter=Number(query.get('diameter'));
 let photoSource='';
 function choices(id,values,selected){
  const el=$(id);el.replaceChildren(...values.map(v=>{const option=document.createElement('option');option.value=String(v.value);option.textContent=v.label;return option;}));el.value=String(selected??'');
 }
 function refresh(){
  P.normalize(p,state);equipmentState={brand:'lc',model:p,selection:state};equipmentButtons(P.total(p,state).unknown.length>0);const v=P.variant(p,state),t=P.total(p,state),colors=P.colors(p,state),diameters=P.diameters(p,state);
  const variants=p.variants.filter(x=>!v.groups||x.groups===v.groups);
  choices('lc-variant',variants.map(x=>({value:x.id,label:x.name})),v.id);
  $('lc-groups').value=String(v.groups||'');
  choices('lc-finish',colors.map(c=>({value:c,label:c})),state.finish);
  $('lc-finish-field').hidden=!colors.length;$('lc-standard-finish').hidden=!!colors.length;
  choices('lc-diameter',diameters.map(d=>({value:d,label:'D'+d+' · '+d+' mm'})),state.diameter);
  $('lc-diameter-field').hidden=!diameters.length;
  $('lc-selection').textContent=cimbaliSelection(p,state);
  const photo=cimbaliPhoto(p,state);
  if(photo.src!==photoSource){$('lc-photo').innerHTML=cimbaliPhotoHTML(p,state,'eager');photoSource=photo.src;}
  $('lc-full-photo').href=photo.src;
  $('lc-photo-note').textContent='Catalogue photograph. '+(v.image?'Selected configuration: '+v.name+'.':'Configuration'+(v.groups?' and group count':'')+' may differ from the photograph.')+(state.finish?' Selected finish: '+state.finish+'; finish-specific photograph is not available.':'');
  for(const input of document.querySelectorAll('[data-cimbali-option]')){
   const o=p.options.find(o=>o.id===input.dataset.cimbaliOption),available=P.available(p,state,o);
   input.checked=state.selected.includes(o.id);input.disabled=!available;
   input.closest('label').querySelector('[data-extra-price]').textContent=available?cimbaliMoney(o.prices_cents[v.id]):'Not available for this selection';
  }
  $('lc-base-price').textContent=cimbaliMoney(t.base);
  if($('lc-required-price'))$('lc-required-price').textContent=v.price_includes_required_water_tank ? (root.dataset.cimbaliIncludedTank || 'Included in machine price') : cimbaliMoney(t.required);
  $('lc-extras-price').textContent=cimbaliMoney(t.extras)+(t.unknown.length?' + on request':'');
  $('lc-total-label').textContent=cimbaliTotalLabel(t);$('lc-price').textContent=cimbaliMoney(t.cents);
  $('lc-selected-options').innerHTML=t.selected.map(o=>`<li><span>${esc(o.name)}</span><span>${cimbaliMoney(o.prices_cents[v.id])}</span></li>`).join('');
  $('lc-selected-options').hidden=!t.selected.length;
  const pending=t.unknown.length?'Price on request: '+t.unknown.map(o=>o.name).join(', ')+'. These items are excluded from the subtotal.':'';
  $('lc-pending').hidden=!pending;$('lc-pending').textContent=pending;
  $('lc-selected-count').textContent=t.selected.length+' selected';
  $('lc-options-label').textContent=cimbaliTotalLabel(t);$('lc-options-total').textContent=cimbaliMoney(t.cents);
  $('lc-options-note').textContent=[pending,cimbaliTaxNote()].filter(Boolean).join(' ');
  $('lc-bottom-total').textContent=cimbaliTotalLabel(t)+': '+cimbaliMoney(t.cents);
  $('lc-specs').innerHTML=`<div class="machine-table-scroll" tabindex="0" role="region" aria-label="Technical specifications; scroll horizontally"><table class="machine-table"><thead><tr><th scope="col">Specification</th><th scope="col">Selected configuration</th></tr></thead><tbody>${cimbaliSpecs(p,state).map(([label,value])=>`<tr><th scope="row">${esc(label)}</th><td>${esc(value)}</td></tr>`).join('')}</tbody></table></div>`;
 }
 $('lc-groups').addEventListener('change',()=>{
  const old=P.variant(p,state),options=p.variants.filter(v=>v.groups===Number($('lc-groups').value));
  const next=options.find(v=>v.controls===old.controls&&v.compact===old.compact)||options[0];
  if(next)state.variantId=next.id;refresh();
 });
 $('lc-variant').addEventListener('change',()=>{state.variantId=$('lc-variant').value;refresh();});
 $('lc-finish').addEventListener('change',()=>{state.finish=$('lc-finish').value;refresh();});
 $('lc-diameter').addEventListener('change',()=>{state.diameter=Number($('lc-diameter').value);refresh();});
 for(const input of document.querySelectorAll('[data-cimbali-option]'))input.addEventListener('change',()=>{P.toggle(p,state,input.dataset.cimbaliOption,input.checked);refresh();});
 for(const id of ['lc-add-to-cart','lc-options-add-to-cart','lc-bottom-add-to-cart'])$(id).addEventListener('click',()=>addMachineToCart(cimbaliCartKey(p,state)));
 refresh();
})();

'use strict';
(() => {
 const select=document.querySelector('#va-model');if(!select)return;
 const bySlug=slug=>machineModels.find(p=>p.slug===slug)||machineModels[0];
 const $=id=>document.getElementById(id);
 let selected=bySlug(new URLSearchParams(location.search).get('model')),gallery=[];
 function selection(){return {version:selected.version,groups:selected.groups,finish:$('va-finish').value};}
 function showView(index){
  const view=gallery[index]||gallery[0];
  $('va-machine-photo').innerHTML=machinePhotoHTML(view,selected.name+' · '+machineViewLabel(view),'eager');
  $('va-photo-name').textContent=machineViewLabel(view);
  $('va-photo-note').textContent=machineViewNote(selected,selection(),view);
  $('va-full-photo').href=view.originalUrl||view.src;$('va-full-photo').hidden=!!view.reference;
  $('va-photo-source').href=view.sourcePage||'#';$('va-photo-source').hidden=!view.sourcePage;
  document.querySelectorAll('[data-brand-view]').forEach(b=>b.setAttribute('aria-pressed',String(Number(b.dataset.brandView)===index)));
 }
 function renderFinish(updateHistory=false,intent){
  const s=selection(),row=selected.configurations.find(c=>c.version===s.version&&c.groups===s.groups),amount=row?.prices[s.finish]??null;
  const total=machineTotals(selected,s);equipmentButtons(total.total===null);
  $('va-price').textContent=total.display;$('va-tax').textContent=total.note;
  $('va-configure-link').href=machineHref(selected)+'?finish='+encodeURIComponent(s.finish);
  gallery=machineViews(selected,s);
  $('va-gallery').innerHTML=gallery.map((v,i)=>`<button type="button" data-brand-view="${i}" aria-label="Show ${machinePhotoEscape(machineViewLabel(v))}" aria-pressed="${i===0}">${machinePhotoHTML(v,'')}<span>${machinePhotoEscape(v.label)}</span></button>`).join('');
  document.querySelectorAll('[data-brand-view]').forEach(button=>button.addEventListener('click',()=>showView(Number(button.dataset.brandView))));showView(machinePrimaryViewIndex(selected,s,gallery,intent));
  if(updateHistory){const url=new URL(location.href);url.searchParams.set('model',selected.slug);url.searchParams.set('finish',s.finish);history.replaceState(null,'',url);}
 }
 function renderModel(slug,updateHistory=false){
  selected=bySlug(slug);select.value=selected.slug;
  $('va-version').textContent=selected.version||'';$('va-version').parentElement.hidden=!selected.version;
  $('va-groups').textContent=selected.groups+' group';
  const finishes=machineAllowedFinishes(selected,selected.version);
  $('va-finish').replaceChildren(...finishes.map(value=>{const option=document.createElement('option');option.value=value;option.textContent=value;return option;}));
  const queryFinish=new URLSearchParams(location.search).get('finish');
  $('va-finish').value=!updateHistory&&finishes.includes(queryFinish)?queryFinish:selected.finish;
  $('va-configure-link').hidden=!selected.detailPath;
  renderFinish(updateHistory);
 }
 select.addEventListener('change',()=>renderModel(select.value,true));
 $('va-finish').addEventListener('change',()=>renderFinish(true,'finish'));
 window.addEventListener('popstate',()=>renderModel(new URLSearchParams(location.search).get('model')));
 $('va-add-to-cart').addEventListener('click',()=>addMachineToCart(victoriaCartKey(selected,selection())));
 renderModel(selected.slug);
})();

'use strict';
for(const section of document.querySelectorAll('[data-cimbali-collection]')){
 const buttons=section.querySelectorAll('[data-cimbali-filter]'),cards=section.querySelectorAll('[data-cimbali-series]');
 for(const button of buttons)button.addEventListener('click',()=>{
  const series=button.dataset.cimbaliFilter;let count=0;
  for(const card of cards){card.hidden=series!=='All'&&card.dataset.cimbaliSeries!==series;if(!card.hidden)count++;}
  for(const b of buttons)b.setAttribute('aria-pressed',String(b===button));
  document.getElementById('lc-count-'+section.dataset.cimbaliCollection).textContent=count+' '+(count===1?'model':'models');
 });
}

for(const form of root.querySelectorAll('[data-grinder-product]')){
 const input=form.querySelector('input[name="quantity"]');
 for(const button of form.querySelectorAll('[data-grinder-step]'))button.addEventListener('click',()=>{input.value=String(Math.max(1,Math.min(99,(Number(input.value)||1)+Number(button.dataset.grinderStep))));});
 form.addEventListener('submit',event=>{event.preventDefault();if(!form.reportValidity())return;const quantity=Number(input.value);if(!Number.isInteger(quantity)||quantity<1||quantity>99)return;const id=form.querySelector('[name="id"]')?.value;const handle=form.dataset.grinderHandle;const price=Number(form.dataset.grinderPrice);const status=form.querySelector('.grinder-cart-status');if(!id||!handle||!Number.isInteger(price)||price<=0){equipmentStatus(form.dataset.grinderError,true,status);return;}equipmentCart([{id,handle,price,quantity,properties:{}}],price*quantity,status);});
}
for(const slider of root.querySelectorAll('[data-category-slider]')){
 const slides=[...slider.querySelectorAll('[data-hero-slide]')];let active=0;
 const controls=slider.querySelector('.category-slider-controls');if(!controls||slides.length<2)continue;controls.hidden=false;
 const pause=controls.querySelector('[data-hero-pause]');if(pause)pause.hidden=true;
 function show(i){active=(i+slides.length)%slides.length;slides.forEach((s,j)=>s.hidden=j!==active);slider.querySelectorAll('[data-hero-dot]').forEach((b,j)=>b.setAttribute('aria-pressed',String(j===active)));const c=slider.querySelector('[data-hero-count]');if(c)c.textContent=(active+1)+' / '+slides.length;}
 for(const b of slider.querySelectorAll('[data-hero-step]'))b.addEventListener('click',()=>show(active+Number(b.dataset.heroStep)));
 for(const b of slider.querySelectorAll('[data-hero-dot]'))b.addEventListener('click',()=>show(Number(b.dataset.heroDot)));
 let start=null;slider.addEventListener('touchstart',e=>{start=e.changedTouches[0].clientX;},{passive:true});slider.addEventListener('touchend',e=>{if(start===null)return;const distance=e.changedTouches[0].clientX-start;if(Math.abs(distance)>55)show(active+(distance<0?1:-1));start=null;},{passive:true});
}
const gallery=root.querySelector('#md-photo');
if(gallery){let start=null;gallery.style.touchAction='pan-y pinch-zoom';gallery.addEventListener('touchstart',e=>{start=e.changedTouches[0].clientX;},{passive:true});gallery.addEventListener('touchend',e=>{const d=e.changedTouches[0].clientX-start;if(start!==null&&Math.abs(d)>55){const buttons=[...root.querySelectorAll('[data-detail-view]')];const index=buttons.findIndex(b=>b.getAttribute('aria-pressed')==='true');buttons[(index+(d<0?1:-1)+buttons.length)%buttons.length]?.click();}start=null;},{passive:true});}
for(const a of root.querySelectorAll('a[href]')){if(a.getAttribute('href').startsWith('/products/')||a.getAttribute('href').startsWith('/collections/')){const preview=new URLSearchParams(location.search).get('preview_theme_id');if(preview){const url=new URL(a.href,location.origin);url.searchParams.set('preview_theme_id',preview);a.href=url.href;}}}

})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["mood-equipment-toolbar"] && !Shopify.designMode) return;
  try {
    (() => {
  const root = document.getElementById('mood-equipment-toolbar');
  if (!root || root.dataset.ready) return;
  root.dataset.ready = 'true';
  const mobileViewport = window.matchMedia('(max-width: 991px)');
  const desktopAnchor = document.createElement('span');
  desktopAnchor.hidden = true;
  root.before(desktopAnchor);
  let layoutFrame = 0;
  let previewFrame = null;
  const previewObserver = new ResizeObserver(() => scheduleLayout());
  const floatingWidgets = new Map();
  function syncFloatingWidgets() {
    const restoreWidget = (widget, saved) => {
      saved.observer.disconnect();
      Object.entries(saved.styles).forEach(([property, original]) => {
        if (original.value) widget.style.setProperty(property, original.value, original.priority);
        else widget.style.removeProperty(property);
      });
      widget.removeAttribute('data-mood-nav-positioned');
      floatingWidgets.delete(widget);
    };
    floatingWidgets.forEach((saved, widget) => {
      if (!mobileViewport.matches || !widget.isConnected) restoreWidget(widget, saved);
    });
    if (!mobileViewport.matches) return;
    document.querySelectorAll('[id^="gb-widget-"]').forEach(widget => {
      if (!floatingWidgets.has(widget)) {
        const styles = Object.fromEntries(['bottom', 'z-index'].map(property => [property, {
          value: widget.style.getPropertyValue(property),
          priority: widget.style.getPropertyPriority(property)
        }]));
        const observer = new MutationObserver(scheduleLayout);
        observer.observe(widget, {attributes: true, attributeFilter: ['style']});
        floatingWidgets.set(widget, {styles, observer});
      }
      const styles = {
        bottom: 'calc(var(--mood-mobile-nav-height) + var(--mood-mobile-preview-offset) + 78px)',
        'z-index': '999'
      };
      Object.entries(styles).forEach(([property, value]) => {
        if (widget.style.getPropertyValue(property) !== value || widget.style.getPropertyPriority(property) !== 'important') {
          widget.style.setProperty(property, value, 'important');
        }
      });
      widget.setAttribute('data-mood-nav-positioned', 'true');
    });
  }
  function syncLayout() {
    layoutFrame = 0;
    document.body.classList.toggle('mood-mobile-navigation', mobileViewport.matches);
    if (!mobileViewport.matches) {
      if (root.previousElementSibling !== desktopAnchor) desktopAnchor.after(root);
      document.documentElement.style.removeProperty('--mood-mobile-nav-height');
      document.documentElement.style.removeProperty('--mood-mobile-preview-offset');
      syncFloatingWidgets();
      return;
    }
    if (root.parentElement !== document.body) document.body.append(root);
    document.documentElement.style.setProperty('--mood-mobile-nav-height', Math.ceil(root.getBoundingClientRect().height) + 'px');
    const nextFrame = document.getElementById('PBarNextFrame');
    if (nextFrame !== previewFrame) {
      if (previewFrame) previewObserver.unobserve(previewFrame);
      previewFrame = nextFrame;
      if (previewFrame) previewObserver.observe(previewFrame);
    }
    const frameBox = previewFrame?.getBoundingClientRect();
    const offset = frameBox && frameBox.height < 160 && getComputedStyle(previewFrame).visibility !== 'hidden' ? Math.max(0, Math.min(frameBox.height, window.innerHeight - frameBox.top)) : 0;
    document.documentElement.style.setProperty('--mood-mobile-preview-offset', Math.ceil(offset) + 'px');
    syncFloatingWidgets();
  }
  function scheduleLayout() {
    if (!layoutFrame) layoutFrame = requestAnimationFrame(syncLayout);
  }
  new ResizeObserver(scheduleLayout).observe(root);
  new MutationObserver(scheduleLayout).observe(document.body, {childList:true});
  mobileViewport.addEventListener('change', scheduleLayout);
  window.addEventListener('resize', scheduleLayout, {passive:true});
  window.addEventListener('pageshow', scheduleLayout);
  window.visualViewport?.addEventListener('resize', scheduleLayout, {passive:true});
  syncLayout();
  const translations = JSON.parse(root.querySelector('[data-toolbar-translations]').textContent);
  const text = (key, values = {}) => Object.entries(values).reduce((value, [name, replacement]) => value.replaceAll('{' + name + '}', String(replacement)), translations[key] || '');
  const base = window.Shopify?.routes?.root || root.dataset.rootUrl || '/';
  const currency = root.dataset.currency || 'AED';
  const money = value => new Intl.NumberFormat(document.documentElement.lang || 'en', { style: 'currency', currency, currencyDisplay: 'code', minimumFractionDigits: Number(value) % 1 ? 2 : 0, maximumFractionDigits: 2 }).format(Number(value));
  const dialog = root.querySelector('dialog');
  const input = root.querySelector('#mood-toolbar-search-input');
  const status = root.querySelector('[data-toolbar-status]');
  const results = root.querySelector('[data-toolbar-results]');
  const chips = root.querySelector('[data-toolbar-chips]');
  const unmatched = root.querySelector('[data-toolbar-unmatched]');
  const fullSearch = root.querySelector('[data-toolbar-full-search]');
  const categories = new Set();
  const cache = new Map();
  let opener = null;
  let timer;
  let request;
  let revision = 0;
  let lastProducts = [];
  let lastTerms = [];
  let cartRequest;
  const normalise = value => String(value).normalize('NFKD').replace(/[\u0300-\u036f]/g, '').toLowerCase().replace(/([a-z])(\d)/g, '$1 $2').replace(/[^\p{L}\p{N}]+/gu, ' ').trim();
  const parseItems = raw => [...new Map(String(raw).split(/[,;\n\r،]+/).map(value => value.trim()).filter(value => normalise(value)).map(value => [normalise(value), value])).values()];
  const productText = product => normalise([product.title, product.type, product.vendor, ...(product.tags || []), ...(product.variants || []).map(variant => variant.title)].filter(Boolean).join(' '));
  const matches = (product, term) => normalise(term).split(' ').every(token => productText(product).includes(token));
  function productCategory(product) {
    const value = normalise([product.type, product.title].join(' '));
    const vendor = normalise(product.vendor || '');
    if (/\bgrinder\b|\bgrinders\b/.test(value) || /\beureka\b/.test(vendor)) return 'grinders';
    if (/\bcoffee machine\b|\bespresso machine\b|\bcoffee maker\b/.test(value) || /\bcimbali\b|\bvictoria arduino\b/.test(vendor)) return 'machines';
    if (/\bcapsule\b|\bcapsules\b/.test(value)) return 'capsules';
    if (/\bdrip\b|\bpour over\b/.test(value)) return 'drip';
    if (/\bbeans\b|\bbean\b|\bground coffee\b|\bturkish coffee\b|\barabic coffee\b|\bspecialty coffee\b|\bspeciality coffee\b/.test(value)) return 'beans';
    return 'other';
  }
  function safeLink(value) {
    const url = new URL(value, location.origin);
    if (url.origin !== location.origin || !url.pathname.startsWith(base)) return null;
    const preview = new URLSearchParams(location.search).get('preview_theme_id');
    if (preview) url.searchParams.set('preview_theme_id', preview);
    return url.href;
  }
  function element(tag, className, content) {
    const node = document.createElement(tag);
    if (className) node.className = className;
    if (content !== undefined) node.textContent = content;
    return node;
  }
  function renderNavigation(terms) {
    chips.replaceChildren();
    chips.hidden = terms.length < 2;
    if (terms.length > 1) terms.forEach((term, index) => {
      const button = element('button', '', term + ' ×');
      button.type = 'button';
      button.setAttribute('aria-label', text('remove_item', { item: term }));
      button.addEventListener('click', () => { input.value = terms.filter((_, itemIndex) => itemIndex !== index).join(', '); scheduleSearch(true); input.focus(); });
      chips.append(button);
    });
    fullSearch.replaceChildren();
    fullSearch.hidden = !terms.length;
    terms.slice(0, 10).forEach(term => {
      const url = new URL(root.dataset.searchUrl, location.origin);
      url.searchParams.set('q', term);
      url.searchParams.set('type', 'product');
      const link = element('a', '', text('full_search', { item: term }));
      link.href = safeLink(url.href);
      fullSearch.append(link);
    });
  }
  function renderResults(products, terms) {
    const filtered = products.filter(product => !categories.size || categories.has(productCategory(product)));
    results.replaceChildren();
    filtered.forEach(product => {
      const href = safeLink(product.url || base + 'products/' + encodeURIComponent(product.handle));
      if (!href) return;
      const link = element('a', 'mood-toolbar-result');
      link.href = href;
      const imageUrl = product.featured_image?.url || product.image;
      if (imageUrl) {
        const url = new URL(imageUrl, location.origin);
        if (url.protocol === 'https:') {
          const image = element('img');
          image.src = url.href;
          image.alt = '';
          image.width = 76;
          image.height = 76;
          image.loading = 'lazy';
          link.append(image);
        }
      }
      const copy = element('span', 'mood-toolbar-result-copy');
      copy.append(element('strong', '', product.title));
      if (product.vendor) copy.append(element('span', '', product.vendor));
      const rawPrice = product.price_min ?? product.price;
      const price = rawPrice === null || rawPrice === undefined || rawPrice === '' ? NaN : Number(rawPrice);
      const maximum = Number(product.price_max ?? product.price);
      const priceText = Number.isFinite(price) ? maximum > price ? text('from_price', { price: money(price) }) : money(price) : text('price_on_page');
      copy.append(element('span', 'mood-toolbar-result-price', priceText));
      copy.append(element('span', 'mood-toolbar-result-action', text(productCategory(product) === 'machines' ? 'configure_machine' : 'view_product') + ' →'));
      if (product.available === false) copy.append(element('span', '', text('unavailable')));
      link.append(copy);
      results.append(link);
    });
    status.textContent = filtered.length ? text('suggestion_count', { count: filtered.length }) : text('no_results');
    const missing = terms.filter(term => !filtered.some(product => matches(product, term)));
    unmatched.hidden = !missing.length || !filtered.length;
    unmatched.textContent = text('unmatched', { items: missing.join(', ') });
  }
  async function suggestions(term, signal) {
    const key = normalise(term);
    const saved = cache.get(key);
    if (saved && Date.now() - saved.time < 30000) return saved.products;
    const url = new URL(base + 'search/suggest.json', location.origin);
    url.searchParams.set('q', term);
    url.searchParams.set('resources[type]', 'product');
    url.searchParams.set('resources[limit]', '10');
    url.searchParams.set('resources[options][unavailable_products]', 'last');
    url.searchParams.set('resources[options][fields]', 'title,product_type,variants.title,vendor,tag');
    const response = await fetch(url, { signal, headers: { Accept: 'application/json' } });
    if (!response.ok) throw new Error('Search unavailable');
    const data = await response.json();
    const products = (data.resources?.results?.products || []).filter(product => matches(product, term));
    if (cache.size > 40) cache.delete(cache.keys().next().value);
    cache.set(key, { time: Date.now(), products });
    return products;
  }
  async function runSearch(currentRevision) {
    const terms = parseItems(input.value);
    renderNavigation(terms);
    unmatched.hidden = true;
    if (!terms.length || terms.length > 10) {
      lastProducts = [];
      lastTerms = terms;
      results.replaceChildren();
      results.removeAttribute('aria-busy');
      status.textContent = text(terms.length > 10 ? 'item_limit' : 'search_empty');
      return;
    }
    request = new AbortController();
    const signal = request.signal;
    status.textContent = text('search_loading');
    results.setAttribute('aria-busy', 'true');
    try {
      const found = new Map();
      let cursor = 0;
      await Promise.all(Array.from({ length: Math.min(3, terms.length) }, async () => {
        while (cursor < terms.length) {
          const term = terms[cursor++];
          for (const product of await suggestions(term, signal)) found.set(String(product.id), product);
        }
      }));
      if (currentRevision !== revision || !dialog.open) return;
      lastProducts = [...found.values()];
      lastTerms = terms;
      renderResults(lastProducts, lastTerms);
    } catch (error) {
      if (error.name !== 'AbortError' && currentRevision === revision) {
        lastProducts = [];
        lastTerms = terms;
        results.replaceChildren();
        status.textContent = text('search_failed');
      }
    } finally {
      if (currentRevision === revision) results.removeAttribute('aria-busy');
    }
  }
  function scheduleSearch(immediate = false) {
    clearTimeout(timer);
    request?.abort();
    revision++;
    const currentRevision = revision;
    if (immediate) runSearch(currentRevision);
    else timer = setTimeout(() => runSearch(currentRevision), 280);
  }
  root.querySelectorAll('[data-toolbar-search-open]').forEach(trigger => trigger.addEventListener('click', event => {
    if (typeof dialog.showModal !== 'function') return;
    event.preventDefault();
    opener = event.currentTarget.closest('[data-toolbar-popover]')?.querySelector('summary') || event.currentTarget;
    root.querySelectorAll('[data-toolbar-popover]').forEach(panel => { panel.open = false; });
    dialog.showModal();
    input.focus();
    scheduleSearch(true);
  }));
  root.querySelector('[data-toolbar-close]').addEventListener('click', () => dialog.close());
  dialog.addEventListener('close', () => { clearTimeout(timer); request?.abort(); revision++; opener?.focus(); });
  dialog.addEventListener('click', event => {
    if (event.target !== dialog) return;
    const box = dialog.getBoundingClientRect();
    if (event.clientX < box.left || event.clientX > box.right || event.clientY < box.top || event.clientY > box.bottom) dialog.close();
  });
  input.addEventListener('input', () => scheduleSearch());
  input.addEventListener('paste', event => {
    const pasted = event.clipboardData?.getData('text');
    if (!pasted || !/[\r\n]/.test(pasted)) return;
    event.preventDefault();
    const start = input.selectionStart ?? input.value.length;
    const end = input.selectionEnd ?? start;
    const allowed = Math.max(0, input.maxLength - input.value.length + end - start);
    input.setRangeText(pasted.replace(/[\r\n]+/g, ', ').slice(0, allowed), start, end, 'end');
    scheduleSearch();
  });
  root.querySelector('form').addEventListener('submit', event => { event.preventDefault(); scheduleSearch(true); });
  root.querySelector('[data-toolbar-clear]').addEventListener('click', () => {
    input.value = '';
    categories.clear();
    root.querySelectorAll('[data-toolbar-category]').forEach(button => button.setAttribute('aria-pressed', String(button.dataset.toolbarCategory === 'all')));
    scheduleSearch(true);
    input.focus();
  });
  root.querySelectorAll('[data-toolbar-category]').forEach(button => button.addEventListener('click', () => {
    const category = button.dataset.toolbarCategory;
    if (category === 'all') categories.clear();
    else if (categories.has(category)) categories.delete(category);
    else categories.add(category);
    root.querySelectorAll('[data-toolbar-category]').forEach(control => control.setAttribute('aria-pressed', String(control.dataset.toolbarCategory === 'all' ? !categories.size : categories.has(control.dataset.toolbarCategory))));
    if (lastTerms.length && JSON.stringify(lastTerms.map(normalise)) === JSON.stringify(parseItems(input.value).map(normalise))) renderResults(lastProducts, lastTerms);
    else scheduleSearch(true);
  }));
  const brands = root.querySelector('.mood-toolbar-brands');
  const panels = [...root.querySelectorAll('[data-toolbar-popover]')];
  const syncPanels = () => document.body.classList.toggle('mood-mobile-nav-panel-open', mobileViewport.matches && panels.some(panel => panel.open));
  const closePanels = () => { panels.forEach(panel => { panel.open = false; }); syncPanels(); };
  panels.forEach(panel => {
    panel.addEventListener('toggle', () => { if (panel.open) panels.forEach(other => { if (other !== panel) other.open = false; }); syncPanels(); });
    panel.addEventListener('keydown', event => { if (event.key === 'Escape' && panel.open) { event.preventDefault(); panel.open = false; panel.querySelector('summary').focus(); } });
    panel.addEventListener('focusout', () => setTimeout(() => { if (!panel.contains(document.activeElement)) panel.open = false; }, 0));
    panel.querySelector('[data-toolbar-panel-close]')?.addEventListener('click', () => { panel.open = false; panel.querySelector('summary').focus(); });
  });
  document.addEventListener('click', event => { if (!panels.some(panel => panel.contains(event.target))) closePanels(); });
  root.querySelector('[data-toolbar-sidebar]')?.addEventListener('click', closePanels);
  mobileViewport.addEventListener('change', closePanels);
  root.querySelectorAll('a[href]').forEach(link => { const href = safeLink(link.href); if (href) link.href = href; });
  const path = location.pathname.replace(/\/$/, '');
  root.querySelectorAll('.mood-toolbar-category[href]').forEach(link => { if (new URL(link.href).pathname.replace(/\/$/, '') === path) link.setAttribute('aria-current', 'page'); });
  if (!path.includes('grinder') && (path.includes('cimbali') || path.includes('victoria-arduino'))) brands.querySelector('summary').setAttribute('aria-current', 'page');
  async function refreshCart() {
    cartRequest?.abort();
    cartRequest = new AbortController();
    const totals = root.querySelectorAll('[data-toolbar-cart-total]');
    try {
      const response = await fetch(base + 'cart.js', { signal: cartRequest.signal, cache: 'no-store', headers: { Accept: 'application/json' } });
      if (!response.ok) throw new Error('Cart unavailable');
      const cart = await response.json();
      if (!Number.isFinite(Number(cart.total_price))) return;
      const formattedTotal = new Intl.NumberFormat(document.documentElement.lang || 'en', { style: 'currency', currency: cart.currency || currency, currencyDisplay: 'code', minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(Number(cart.total_price) / 100);
      totals.forEach(total => { total.textContent = formattedTotal; total.removeAttribute('title'); });
    } catch (error) {
      if (error.name !== 'AbortError') totals.forEach(total => { total.title = text('cart_unavailable'); });
    }
  }
  document.addEventListener('cart:refresh', refreshCart);
  window.addEventListener('pageshow', event => { if (event.persisted) refreshCart(); });
  document.addEventListener('visibilitychange', () => { if (!document.hidden) refreshCart(); });
  let cartRefreshTimer;
  const cartIndicator = document.querySelector('.site-header__cart-indicator');
  if (cartIndicator) new MutationObserver(() => {
    clearTimeout(cartRefreshTimer);
    cartRefreshTimer = setTimeout(refreshCart, 120);
  }).observe(cartIndicator, {childList:true,subtree:true,characterData:true});
  refreshCart();
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["mood-grinders-hero"] && !Shopify.designMode) return;
  try {
    document.addEventListener('click',function(event){
  var link=event.target.closest('[data-grinder-explore]');
  if(!link)return;
  var target=document.getElementById('product-grid');
  if(!target)return;
  var section=target.closest('.main-collection');
  event.preventDefault();
  event.stopPropagation();
  var reduced=window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var offset=window.matchMedia('(min-width: 990px)').matches?120:16;
  window.scrollTo({top:window.scrollY+(section||target).getBoundingClientRect().top-offset,behavior:reduced?'instant':'smooth'});
  target.setAttribute('tabindex','-1');
  target.focus({preventScroll:true});
},true);
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["mood-lm-script"] && !Shopify.designMode) return;
  try {
    (() => {
  const mount = root => {
    if (root.dataset.ready) return;
    root.dataset.ready = 'true';
    const data = JSON.parse(root.querySelector('[data-lm-data]').textContent);
    const words = JSON.parse(root.querySelector('[data-lm-words]').textContent);
    const money = value => value === null ? words.requestPrice : 'AED ' + new Intl.NumberFormat('en-AE', {maximumFractionDigits:2}).format(value);
    const collection = root.querySelector('[data-lm-collection]');
    const article = root.querySelector('[data-lm-model]');
    const model = data.models.find(m => m.id === article?.dataset.lmModel);
    const store = article?.querySelector('[data-lm-shopify]');
    const shopify = store ? JSON.parse(store.textContent) : {variants:[]};
    const optionStore = root.querySelector('[data-lm-option-variants]');
    const optionShopify = optionStore ? JSON.parse(optionStore.textContent) : {variants:[]};
    const optionSkuFor = option => optionShopify.variants.find(v => v.sku === 'MOOD-LM-'+model.id+'-'+option.id);
    let purchase = null;
    const initial = model?.variants.find(v => v.id === model.initialVariant);
    const skuFor = variant => shopify.variants.find(sku => {
      const group = sku.title.match(/^\s*(\d+)\b/);
      if (group) return Number(group[1]) === variant.groups && variant.mode === initial.mode && (variant.finish || '') === (initial.finish || '');
      if (sku.title === 'Default Title') return variant.id === initial.id;
      return sku.title.toLowerCase() === variant.mode.toLowerCase() || sku.title.toLowerCase() === (variant.finish || '').toLowerCase();
    });
    const selectedSku = shopify.variants.find(v => String(v.id) === String(shopify.selected));
    const selectedCatalogue = model?.variants.find(v => selectedSku && skuFor(v)?.id === selectedSku.id);
    const requestedConfiguration = new URLSearchParams(location.search).get('configuration');
    const state = {variantId:model?.variants.some(v => v.id === requestedConfiguration) ? requestedConfiguration : selectedCatalogue?.id || initial?.id, selected:{}, ral:'', quantity:1, photoFinish:null, busy:false};
    const compatible = (option, variant) => !(option.excludeAbr && variant.abr) && !(option.excludeModes || []).includes(variant.mode) && (!option.groups || option.groups.includes(variant.groups));
    const available = (option, variant) => compatible(option, variant) && !(option.requires || []).some(id => !state.selected[id]);
    const setText = (selector, value) => article.querySelectorAll(selector).forEach(el => el.textContent = value);
    const fill = (selector, values, selected) => {
      const field = article.querySelector(selector);
      field.replaceChildren(...[...new Set(values)].map(value => {
        const option = document.createElement('option');
        option.value = String(value);
        option.textContent = String(value);
        option.selected = String(value) === String(selected);
        return option;
      }));
    };
    const showPhoto = thumb => {
      const img = article.querySelector('[data-lm-main-image]'), source = thumb.querySelector('img');
      img.src = source.src;img.alt = source.alt;img.width = source.width;img.height = source.height;
      article.querySelector('[data-lm-image-caption]').textContent = source.alt;
      article.querySelector('[data-lm-large-image]').href = source.src;
      article.querySelectorAll('[data-lm-thumb]').forEach(t => t.setAttribute('aria-pressed',String(t === thumb)));
    };
    const update = () => {
      if (!model) return;
      const variant = model.variants.find(v => v.id === state.variantId) || initial;
      state.variantId = variant.id;
      let changed = true;
      while (changed) {
        changed = false;
        for (const id of Object.keys(state.selected)) {
          const option = model.options.find(o => o.id === id);
          if (!option || !available(option, variant)) {delete state.selected[id];changed = true;}
        }
      }
      const chosen = model.options.filter(o => state.selected[o.id]);
      const sku = skuFor(variant);
      const direct = !!sku && chosen.every(o => !o.confirm && o.price !== null && (o.price === 0 || !!optionSkuFor(o)));
      const purchasable = direct && sku.available && chosen.every(o => o.price === 0 || optionSkuFor(o).available);
      const base = sku ? sku.price / 100 : variant.price;
      const required = sku ? 0 : variant.required.reduce((sum,o) => sum + o.price,0);
      const extras = chosen.reduce((sum,o) => sum + (optionSkuFor(o) ? optionSkuFor(o).price / 100 : o.price || 0) * state.selected[o.id],0);
      const pending = base === null || chosen.some(o => o.price === null || o.confirm);
      const total = base === null ? null : base + required + extras;
      fill('[data-lm-mode]', model.variants.map(v => v.mode), variant.mode);
      fill('[data-lm-groups]', model.variants.filter(v => v.mode === variant.mode).map(v => v.groups), variant.groups);
      article.querySelector('[data-lm-groups-field]').hidden = !model.variants.some(v => v.groups > 0);
      fill('[data-lm-finish]', model.variants.filter(v => v.mode === variant.mode && v.groups === variant.groups).map(v => v.finish || '').filter(Boolean), variant.finish);
      article.querySelector('[data-lm-finish-field]').hidden = !variant.finish;
      article.querySelector('[data-lm-variant]').value = variant.id;
      setText('[data-lm-selection]',variant.name);
      const finish = (variant.finish || variant.mode).toLowerCase().replace(/ body$/, '');
      if (finish !== state.photoFinish) {
        const thumb = [...article.querySelectorAll('[data-lm-thumb]')].find(t => t.querySelector('img').alt.toLowerCase().includes(finish));
        if (thumb) showPhoto(thumb);
        state.photoFinish = finish;
      }
      setText('[data-lm-base]',money(base));
      setText('[data-lm-required]',money(required));
      article.querySelector('[data-lm-required-row]').hidden = !required;
      setText('[data-lm-extras]',money(extras));
      setText('[data-lm-total]',money(total));
      setText('[data-lm-total-label]',words.total);
      article.querySelector('[data-lm-pending]').hidden = direct;
      setText('[data-lm-pending]',words.quoteNote);
      setText('[data-lm-tax]',sku ? words.taxNote : words.basis);
      const included = [...variant.included, ...variant.required.map(o => o.name + ': ' + money(o.price))];
      setText('[data-lm-included]',included.join(' · '));
      article.querySelector('[data-lm-included]').hidden = !included.length;
      setText('[data-lm-current]',variant.name);
      const selectedOptions = article.querySelector('[data-lm-selected-options]');
      selectedOptions.replaceChildren(...chosen.map(o => {
        const li = document.createElement('li');
        li.textContent = state.selected[o.id] + ' × ' + o.name;
        return li;
      }));
      selectedOptions.hidden = !chosen.length;
      const rows = article.querySelector('[data-lm-specs]');
      rows.replaceChildren(...Object.entries(model.specs[String(variant.groups)] || {}).map(([key,value]) => {
        const tr = document.createElement('tr'), th = document.createElement('th'), td = document.createElement('td');
        th.scope = 'row';th.textContent = key;td.textContent = value;tr.append(th,td);return tr;
      }));
      model.options.forEach(option => {
        const row = article.querySelector('[data-lm-option-row="'+option.id+'"]');
        if (!row) return;
        const field = row.querySelector('[data-lm-option]');
        const pricedOption = optionSkuFor(option);
        if (pricedOption) row.querySelector('.lm-option-price').textContent = money(pricedOption.price / 100);
        const enabled = available(option,variant);
        field.disabled = !enabled;
        row.classList.toggle('lm-unavailable',!enabled);
        row.classList.toggle('lm-option-selected',!!state.selected[option.id]);
        if (field.type === 'checkbox') field.checked = !!state.selected[option.id];
        else field.value = String(state.selected[option.id] || 0);
        row.querySelector('[data-lm-unavailable]').hidden = enabled;
      });
      article.querySelectorAll('[data-lm-select-row]').forEach(row => row.classList.toggle('lm-selected',row.dataset.lmSelectRow === variant.id));
      const ralNeeded = chosen.some(o => o.ral);
      article.querySelector('[data-lm-ral-field]').hidden = !ralNeeded;
      const ralField = article.querySelector('[data-lm-ral]');
      ralField.required = ralNeeded && direct;
      const purchaseForm = article.querySelector('[data-lm-purchase]');
      if (purchaseForm) ralField.setAttribute('form',purchaseForm.getAttribute('id'));
      const lines = ['La Marzocco '+model.name,variant.name,words.quantity+': '+state.quantity,words.base+': '+money(base)];
      variant.required.forEach(o => lines.push(o.name+': '+money(o.price)));
      chosen.forEach(o => lines.push(state.selected[o.id]+' × '+o.name+': '+money(o.price === null ? null : o.price * state.selected[o.id])+(o.confirm ? ' ('+words.compatibility+')' : '')));
      if (ralNeeded) lines.push('RAL: '+(state.ral || words.requiredRal));
      lines.push(words.total+': '+money(total));
      if (!direct) lines.push(words.quoteNote,words.confirmNotice);
      const text = lines.join('\n');
      article.querySelectorAll('[data-lm-quote]').forEach(link => link.href = 'mailto:cs@bestaromaticohits.com?subject='+encodeURIComponent('La Marzocco '+model.name+' quotation')+'&body='+encodeURIComponent(text));
      article.querySelectorAll('[data-lm-quote-action]').forEach(link => link.hidden = direct);
      article.querySelector('[data-lm-whatsapp]').href = 'https://wa.me/971527016501?text='+encodeURIComponent(text);
      article.querySelector('[data-lm-quote-text]').value = text;
      setText('[data-lm-selection-count]',String(chosen.reduce((sum,o) => sum+state.selected[o.id],0)));
      const form = article.querySelector('[data-lm-purchase]');
      if (form) {
        form.hidden = !purchasable;
        form.querySelector('[data-lm-purchase-id]').value = purchasable ? String(sku.id) : '';
        form.querySelector('[data-lm-purchase-configuration]').value = variant.name;
      }
      article.querySelectorAll('[data-lm-buy]').forEach(button => {button.hidden = !purchasable;button.disabled = !purchasable || state.busy;});
      article.querySelector('[data-lm-sold-out]').hidden = !direct || purchasable;
      purchase = purchasable ? {sku,variant,chosen,total,ralNeeded} : null;
    };
    root.addEventListener('submit',async event => {
      if (!event.target.matches('[data-lm-purchase]')) return;
      event.preventDefault();
      event.stopPropagation();
      const form = event.target;
      if (state.busy || !form.reportValidity()) return;
      update();
      if (!purchase) return;
      const errorNode = article.querySelector('[data-lm-purchase-error]');
      errorNode.hidden = true;
      const quantity = Number(article.querySelector('[data-lm-quantity]').value);
      if (!Number.isInteger(quantity) || quantity < 1 || quantity > 99) {
        errorNode.textContent = words.invalidQuantity;errorNode.hidden = false;return;
      }
      const selected = purchase;
      const group = crypto.randomUUID();
      const properties = {'Configuration':selected.variant.name,'Selected options':selected.chosen.map(o => state.selected[o.id]+' × '+o.name).join(', ') || 'None','_Mood LM group':group,'_Mood LM units':'1'};
      if (selected.ralNeeded) properties['RAL'] = state.ral;
      const items = [{id:selected.sku.id,quantity,properties}];
      const expected = [{id:selected.sku.id,handle:shopify.handle,price:selected.sku.price,quantity}];
      for (const option of selected.chosen) {
        if (option.price === 0) continue;
        const optionSku = optionSkuFor(option);
        const units = state.selected[option.id];
        const detail = {'For machine':'La Marzocco '+model.name,'Configuration':selected.variant.name,'_Mood LM group':group,'_Mood LM units':String(units),'_Mood LM option':option.id};
        if (option.ral) detail['RAL'] = state.ral;
        items.push({id:optionSku.id,quantity:quantity*units,parent_id:selected.sku.id,properties:detail});
        expected.push({id:optionSku.id,handle:optionShopify.handle,price:optionSku.price,quantity:quantity*units});
      }
      state.busy = true;update();
      try {
        if (!window.MoodCart) throw Error(words.error);
        const base = window.Shopify?.routes?.root || '/';
        const catalogs = new Map(await Promise.all([...new Set(expected.map(i => i.handle))].map(async handle => {
          const response = await fetch(base+'products/'+encodeURIComponent(handle)+'.js',{headers:{Accept:'application/json'},cache:'no-store'});
          if (!response.ok) throw Error(words.priceChanged);
          return [handle,await response.json()];
        })));
        let actual = 0;
        for (const item of expected) {
          const variant = catalogs.get(item.handle).variants.find(v => String(v.id) === String(item.id));
          if (!variant?.available || variant.price !== item.price) throw Error(words.priceChanged);
          actual += variant.price*item.quantity;
        }
        if (actual !== Math.round(selected.total*100)*quantity) throw Error(words.priceChanged);
        await window.MoodCart.add({items},article);
      } catch (error) {
        errorNode.textContent = error.message || words.error;errorNode.hidden = false;
        errorNode.scrollIntoView({block:'center',behavior:'smooth'});
      } finally {state.busy = false;update();}
    });
    root.addEventListener('change',event => {
      if (!model) return;
      const field = event.target;
      const current = model.variants.find(v => v.id === state.variantId);
      if (field.matches('[data-lm-mode],[data-lm-groups],[data-lm-finish]')) {
        const mode = field.matches('[data-lm-mode]') ? field.value : current.mode;
        const groups = field.matches('[data-lm-groups]') ? Number(field.value) : current.groups;
        const finish = field.matches('[data-lm-finish]') ? field.value : current.finish;
        const choices = model.variants.filter(v => v.mode === mode);
        state.variantId = (choices.find(v => v.groups === groups && v.finish === finish) || choices.find(v => v.groups === groups) || choices[0]).id;
      } else if (field.matches('[data-lm-variant]')) state.variantId = field.value;
      else if (field.matches('[data-lm-option]')) {
        const option = model.options.find(o => o.id === field.dataset.lmOption);
        const quantity = field.type === 'checkbox' ? Number(field.checked) : Math.max(0,Math.min(option.maxQuantity || 6,Number(field.value) || 0));
        if (quantity && option.exclusive) model.options.filter(o => o.exclusive === option.exclusive).forEach(o => delete state.selected[o.id]);
        if (quantity) state.selected[option.id] = quantity;else delete state.selected[option.id];
      } else if (field.matches('[data-lm-ral]')) state.ral = field.value.trim().slice(0,60);
      else if (field.matches('[data-lm-quantity]')) state.quantity = Number(field.value) || 1;
      else return;
      update();
    });
    root.addEventListener('input',event => {
      if (!model) return;
      if (event.target.matches('[data-lm-ral]')) state.ral = event.target.value.trim().slice(0,60);
      else if (event.target.matches('[data-lm-quantity]')) state.quantity = Number(event.target.value) || 1;
      else return;
      update();
    });
    root.addEventListener('click',event => {
      if (event.target.closest('[data-lm-explore]')) {
        event.preventDefault();root.querySelector('#lm-range')?.scrollIntoView({block:'start',behavior:'instant'});return;
      }
      const step = event.target.closest('[data-lm-quantity-step]');
      if (step && model) {
        const input = article.querySelector('[data-lm-quantity]');
        input.value = String(Math.max(1,Math.min(99,(Number(input.value) || 1)+Number(step.dataset.lmQuantityStep))));
        state.quantity = Number(input.value);update();
      }
      const thumb = event.target.closest('[data-lm-thumb]');
      if (thumb && model) showPhoto(thumb);
      const select = event.target.closest('[data-lm-choose]');
      if (select && model) {
        state.variantId = select.dataset.lmChoose;update();article.querySelector('[data-lm-config]').scrollIntoView({block:'start',behavior:'instant'});
      }
      const filter = event.target.closest('[data-lm-filter]');
      if (filter && collection) {
        const category = filter.dataset.lmFilter;
        collection.querySelectorAll('[data-lm-card]').forEach(c => c.hidden = category !== 'all' && c.dataset.lmCategory !== category);
        collection.querySelectorAll('[data-lm-filter]').forEach(b => b.setAttribute('aria-pressed',String(b === filter)));
      }
    });
    update();
  };
  document.querySelectorAll('[data-lm-root]').forEach(mount);
  document.addEventListener('shopify:section:load',() => document.querySelectorAll('[data-lm-root]').forEach(mount));
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["mood-unified-cart"] && !Shopify.designMode) return;
  try {
    (() => {
  if (window.MoodCart) return;
  const dialog = document.getElementById('mood-cart-dialog');
  const wordsNode = document.getElementById('mood-cart-words');
  if (!dialog || !wordsNode) return;
  const words = JSON.parse(wordsNode.textContent);
  const base = window.Shopify?.routes?.root || '/';
  const status = dialog.querySelector('[data-mood-cart-status]');
  const itemsNode = dialog.querySelector('[data-mood-cart-items]');
  const active = new WeakSet();
  const savedButtons = new WeakMap();
  let cart = null, serial = Promise.resolve(), refreshTimer, returnFocus;
  const money = value => new Intl.NumberFormat(document.documentElement.lang || 'en', {style:'currency', currency:cart?.currency || words.currency || 'AED'}).format(value / 100);
  const queue = task => { const next = serial.then(task, task); serial = next.catch(() => {}); return next; };
  const node = (tag, className, text) => { const el=document.createElement(tag); if(className)el.className=className; if(text !== undefined)el.textContent=text; return el; };
  const message = (text, error=false) => { status.textContent=text; status.dataset.error=String(error);if(text===words.loading){const checkout=dialog.querySelector('[data-mood-checkout]');checkout.setAttribute('aria-disabled','true');checkout.tabIndex=-1;} };
  function open() {
    if (!dialog.open) { returnFocus=document.activeElement; dialog.showModal(); document.body.classList.add('mood-cart-open'); }
    document.querySelectorAll('.js-mini-cart.active').forEach(el=>el.classList.remove('active'));
  }
  function close() { dialog.close(); document.body.classList.remove('mood-cart-open'); if(!document.querySelector('.modal.show'))document.body.classList.remove('overflow-hidden'); if(returnFocus?.isConnected)returnFocus.focus({preventScroll:true}); }
  function quantity(value, key) {
    const wrap=node('div','mood-quantity');
    const minus=node('button','','−'), input=node('input'), plus=node('button','','+');
    minus.type=plus.type='button'; minus.setAttribute('aria-label',words.decrease); plus.setAttribute('aria-label',words.increase);
    input.type='number'; input.min='0';input.step='1';input.value=String(value);input.setAttribute('aria-label',words.quantity);input.inputMode='numeric';
    minus.addEventListener('click',()=>change(key,Math.max(0,value-1),wrap)); plus.addEventListener('click',()=>change(key,value+1,wrap));
    let editTimer, lastRequested=value;
    const commit=()=>{clearTimeout(editTimer);if(!input.value.trim())return;const n=Number(input.value);if(!Number.isInteger(n)||n<0){input.value=String(value);return;}if(n!==lastRequested){lastRequested=n;change(key,n,wrap);}};
    input.addEventListener('input',()=>{clearTimeout(editTimer);editTimer=setTimeout(commit,400);});
    input.addEventListener('change',commit);
    wrap.append(minus,input,plus); return wrap;
  }
  function paint(data, force=false) {
    const changedItems=force || !cart || JSON.stringify(cart.items)!==JSON.stringify(data.items);
    cart=data;
    document.querySelectorAll('.js-cart-count,[data-mood-cart-count],[data-cart-count]').forEach(el=>{if(el.textContent!==String(data.item_count))el.textContent=String(data.item_count);});
    document.querySelectorAll('.js-cart-total,[data-toolbar-cart-total],[data-mood-cart-total]').forEach(el=>{el.textContent=money(data.total_price);el.removeAttribute('title');});
    document.querySelectorAll('.js-toggle-cart').forEach(el=>{el.setAttribute('aria-label',words.title+' ('+data.item_count+')');el.setAttribute('role','button');el.tabIndex=0;});
    const fragment=document.createDocumentFragment();
    if (!data.items.length) fragment.append(node('p','mood-cart-detail',words.empty));
    for (const item of data.items) {
      const row=node('article','mood-cart-item'); row.dataset.cartKey=item.key;
      const photo=node('a'), content=node('div'); photo.href=item.url;
      if(item.image){const img=node('img');img.src=item.image;img.alt=item.product_title;img.width=72;img.height=84;img.loading='lazy';photo.append(img);}
      const title=node('a','',item.product_title);title.href=item.url;content.append(title);
      if(item.variant_title && item.variant_title!=='Default Title')content.append(node('p','mood-cart-detail',item.variant_title));
      for(const [key,value] of Object.entries(item.properties||{})){if(!key.startsWith('_')&&value)content.append(node('p','mood-cart-detail',key+': '+value));}
      if(item.selling_plan_allocation?.selling_plan?.name)content.append(node('p','mood-cart-detail',item.selling_plan_allocation.selling_plan.name));
      content.append(node('strong','mood-cart-line-price',money(item.final_line_price ?? item.line_price)));
      const controls=node('div','mood-cart-line-actions'), remove=node('button','mood-cart-remove',words.remove);remove.type='button';remove.addEventListener('click',()=>change(item.key,0,controls));if(item.properties?.['_Mood LM option']){controls.append(node('span','mood-cart-detail',words.quantity+': '+item.quantity));}else{controls.append(quantity(item.quantity,item.key),remove);}content.append(controls);row.append(photo,content);fragment.append(row);
    }
    if(changedItems)itemsNode.replaceChildren(fragment);
    decorateCartPage(data);
    const checkout=dialog.querySelector('[data-mood-checkout]');checkout.setAttribute('aria-disabled',String(!data.item_count));checkout.tabIndex=data.item_count?0:-1;
    document.dispatchEvent(new CustomEvent('mood:cart:updated',{detail:{cart:data}}));
  }
  async function request(endpoint, payload) {
    const options={headers:{Accept:'application/json'},credentials:'same-origin',cache:'no-store'};
    if(payload){options.method='POST';if(payload instanceof FormData)options.body=payload;else{options.headers['Content-Type']='application/json';options.body=JSON.stringify(payload);}}
    let response,data;
    try{response=await fetch(base+endpoint,options);data=await response.json();}catch(error){throw Error(words.error);}
    if(!response.ok){const error=Error(typeof data.description==='string'?data.description:typeof data.message==='string'?data.message:words.error);error.rejected=true;throw error;}
    return data;
  }
  async function alignConfigurationQuantities(data){
    const parents=new Map(data.items.filter(item=>item.properties?.['_Mood LM group']&&!item.properties['_Mood LM option']).map(item=>[item.properties['_Mood LM group'],item]));
    const updates={};
    for(const item of data.items){
      if(!item.properties?.['_Mood LM option'])continue;
      const parent=parents.get(item.properties['_Mood LM group']);
      if(!parent)continue;
      const expected=parent.quantity*(Number(item.properties['_Mood LM units'])||1);
      if(item.quantity!==expected)updates[item.key]=expected;
    }
    return Object.keys(updates).length?request('cart/update.js',{updates}):data;
  }
  async function read(){const data=await alignConfigurationQuantities(await request('cart.js'));paint(data);return data;}
  const refresh = () => queue(read);
  const schedule = () => {clearTimeout(refreshTimer);refreshTimer=setTimeout(()=>refresh().catch(()=>{}),120);};
  function lock(el, state) {
    if(!el)return;
    if(state){
      active.add(el);el.setAttribute('aria-busy','true');
      const buttons=el.matches('[data-mood-add]')?[el]:Array.from(el.querySelectorAll('[data-mood-add]'));
      savedButtons.set(el,buttons.map(button=>({button,html:button.innerHTML,disabled:button.disabled,aria:button.getAttribute('aria-disabled')})));
      buttons.forEach(button=>{button.setAttribute('aria-busy','true');button.setAttribute('aria-disabled','true');if('disabled' in button)button.disabled=true;button.textContent=words.adding;});
    }else{
      active.delete(el);el.removeAttribute('aria-busy');
      (savedButtons.get(el)||[]).forEach(({button,html,disabled,aria})=>{button.innerHTML=html;if('disabled' in button)button.disabled=disabled;button.removeAttribute('aria-busy');if(aria===null)button.removeAttribute('aria-disabled');else button.setAttribute('aria-disabled',aria);});savedButtons.delete(el);
    }
  }
  async function add(payload, trigger) {
    if(trigger&&active.has(trigger))return null;
    lock(trigger,true);
    return queue(async()=>{
      let added=false;
      try {
        const result=await request('cart/add.js',payload);added=true;
        if(window.jQuery && window.jQuery('#jsQuickview').hasClass('show'))window.jQuery('#jsQuickview').modal('hide');
        open();message(words.loading);
        await read();message(words.added);return result;
      } catch(error) {
        open();message(words.loading);
        if(!added)await read().catch(()=>{});
        message(added?words.refresh_error:error.message,true);
        if(added)return {added:true,refreshPending:true};
        throw error;
      } finally {lock(trigger,false);}
    });
  }
  async function change(key,value,trigger,reloadPage=false){
    if(active.has(trigger))return;
    const pageForm=reloadPage?trigger.closest('form'):null;
    if(pageForm)pageForm.inert=true;
    lock(trigger,true);message(words.loading);
    try{await queue(async()=>{
      const result = await alignConfigurationQuantities(await request('cart/change.js',{id:key,quantity:value}));
      paint(result);message(words.updated);
      if(reloadPage)window.location.reload();
    });}
    catch(error){if(reloadPage)open();message(error.message,true);await refresh().then(data=>paint(data,true)).catch(()=>{});}
    finally{if(pageForm)pageForm.inert=false;lock(trigger,false);}
  }
  function decorateCartPage(data){
    document.querySelectorAll('main .cart__row').forEach(row=>{
      const input=row.querySelector('input[id^="Updates_"]');
      const item=input&&data.items.find(i=>'Updates_'+i.key===input.id);
      if(!item?.properties?.['_Mood LM group'])return;
      row.dataset.moodLmCartKey=item.key;
      const option=Boolean(item.properties['_Mood LM option']);
      row.dataset.moodLmCartOption=String(option);
      row.querySelectorAll('input[id^="Updates_"]').forEach(field=>{field.value=String(item.quantity);field.readOnly=option;});
      if(option){
        row.querySelectorAll('.js-qty').forEach(wrap=>{
          wrap.hidden=true;
          wrap.style.setProperty('display','none','important');
          if(!wrap.nextElementSibling?.hasAttribute('data-mood-option-quantity')){
            const label=node('span','mood-cart-detail',words.quantity+': '+item.quantity);
            label.setAttribute('data-mood-option-quantity','');wrap.after(label);
          }else wrap.nextElementSibling.textContent=words.quantity+': '+item.quantity;
        });
        row.querySelectorAll('a[href*="/cart/change"]').forEach(link=>{link.hidden=true;});
      }
    });
  }
  document.addEventListener('click',event=>{
    const button=event.target.closest?.('main .cart__row[data-mood-lm-cart-key] .js-qty__adjust');
    if(!button)return;
    event.preventDefault();event.stopImmediatePropagation();
    const row=button.closest('[data-mood-lm-cart-key]');
    if(row.dataset.moodLmCartOption==='true')return;
    const input=button.closest('.js-qty').querySelector('input');
    const value=Math.max(0,(Number(input.value)||0)+(button.classList.contains('js-qty__adjust--minus')?-1:1));
    change(row.dataset.moodLmCartKey,value,row,true);
  },true);
  const commitCartPageQuantity=event=>{
    const input=event.target;
    const row=input.closest?.('main .cart__row[data-mood-lm-cart-key]');
    if(!row||!input.matches('input[id^="Updates_"]'))return;
    event.preventDefault();event.stopImmediatePropagation();
    if(row.dataset.moodLmCartOption==='true')return;
    const value=Number(input.value);
    if(!input.value.trim()||!Number.isInteger(value)||value<0){if(cart)decorateCartPage(cart);return;}
    change(row.dataset.moodLmCartKey,value,row,true);
  };
  document.addEventListener('change',commitCartPageQuantity,true);
  document.addEventListener('keydown',event=>{if(event.key==='Enter')commitCartPageQuantity(event);},true);
  function updateVariant(form){
    const select=form.querySelector('[data-mood-variant]'),data=form.querySelector('[data-mood-variants]');if(!select||!data)return;
    const selected=JSON.parse(data.textContent).find(v=>String(v.id)===select.value);if(!selected)return;
    form.querySelector('[data-mood-variant-price]').textContent=money(selected.price);
    const compare=form.querySelector('[data-mood-compare]');if(compare){compare.hidden=!(selected.compare_at_price>selected.price);compare.textContent=selected.compare_at_price?money(selected.compare_at_price):'';}
    const button=form.querySelector('[type="submit"]');button.disabled=!selected.available;button.textContent=selected.available?words.add:words.unavailable;
  }
  function decorate(scope=document){
    const selector='.js-grid-cart,.qv-add-button,#js-sticky-btn,button[id^="AddToCart-"],.grinder-add,[data-mood-purchase],#mood-equipment button[id$="add-to-cart"]';
    const list=[...(scope.matches?.(selector)?[scope]:[]),...scope.querySelectorAll(selector)];
    for(const el of list){
      if(!el.hasAttribute('data-mood-add'))el.setAttribute('data-mood-add','');
      if(el.matches('.js-grid-cart')){el.setAttribute('role','button');el.tabIndex=0;el.setAttribute('aria-label',words.add);if(!el.classList.contains('disabled')&&el.textContent.trim()!==words.add)el.textContent=words.add;}
      if(el.matches('#mood-equipment button[id$="add-to-cart"]')&&!el.parentElement.querySelector('[data-machine-quantity]')){
        const label=node('label','mood-machine-quantity',words.quantity),wrap=node('div','mood-quantity'),minus=node('button','','−'),input=node('input'),plus=node('button','','+');
        input.type='number';input.min='1';input.max='99';input.value='1';input.step='1';input.inputMode='numeric';input.setAttribute('data-machine-quantity','');input.setAttribute('aria-label',words.quantity);minus.type=plus.type='button';minus.setAttribute('aria-label',words.decrease);plus.setAttribute('aria-label',words.increase);
        const sync=()=>el.closest('#mood-equipment').querySelectorAll('[data-machine-quantity]').forEach(other=>other.value=input.value);input.addEventListener('input',sync);input.addEventListener('change',sync);minus.addEventListener('click',()=>{input.value=String(Math.max(1,(Number(input.value)||1)-1));sync();});plus.addEventListener('click',()=>{input.value=String(Math.min(99,(Number(input.value)||1)+1));sync();});wrap.append(minus,input,plus);label.append(wrap);el.before(label);
      }
    }
  }
  document.addEventListener('submit',event=>{
    const form=event.target;if(!(form instanceof HTMLFormElement)||form.hasAttribute('data-mood-custom-purchase'))return;
    const url=new URL(form.action,location.href);if(!/\/cart\/add(?:\.js)?\/?$/.test(url.pathname)||url.origin!==location.origin)return;
    if(event.submitter?.name==='checkout')return;
    event.preventDefault();event.stopImmediatePropagation();if(!form.reportValidity())return;
    const data=new FormData(form),qty=Number(data.get('quantity')||1);
    if(!Number.isInteger(qty)||qty<1){open();message(words.invalid_quantity,true);return;}
    if(!data.get('id')){open();message(words.unavailable,true);return;}
    add(data,form).catch(()=>{});
  },true);
  document.addEventListener('click',event=>{
    const target=event.target.closest?.('.js-toggle-cart,.mood-toolbar-cart,.js-grid-cart,.qv-add-button,[data-mood-step]');if(!target)return;
    if(event.button!==0||event.ctrlKey||event.metaKey||event.shiftKey||event.altKey)return;
    if(target.matches('[data-mood-step]')){const input=target.closest('.mood-quantity').querySelector('input');input.value=String(Math.max(1,Math.min(99,(Number(input.value)||1)+Number(target.dataset.moodStep))));return;}
    event.preventDefault();event.stopImmediatePropagation();
    if(target.matches('.js-toggle-cart,.mood-toolbar-cart')){open();message(words.loading);refresh().then(()=>message('')).catch(()=>message(words.cart_unavailable,true));return;}
    if(target.disabled||target.classList.contains('disabled')||target.getAttribute('aria-disabled')==='true'||active.has(target))return;
    if(target.matches('.js-grid-cart')){if(target.dataset.id)add({items:[{id:target.dataset.id,quantity:1}]},target).catch(()=>{});return;}
    const modal=target.closest('#jsQuickview');if(!modal)return;
    lock(target,true);
    (async()=>{try{
      const handle=modal.dataset.handle||window.jQuery?.(modal).data('handle');
      if(!handle)throw Error(words.unavailable);
      const product=await request('products/'+encodeURIComponent(handle)+'.js');
      const selectors=Array.from(modal.querySelectorAll('select'));
      const values=selectors.map(s=>s.value);
      const variant=product.variants.length===1?product.variants[0]:product.variants.find(v=>values.length===v.options.length&&v.options.every((value,i)=>value===values[i]));
      if(!variant?.available)throw Error(words.unavailable);
      const qty=Number(modal.querySelector('.qv-quantity')?.value||1);if(!Number.isInteger(qty)||qty<1)throw Error(words.invalid_quantity);
      lock(target,false);await add({items:[{id:variant.id,quantity:qty}]},target);
    }catch(error){open();message(error.message,true);}finally{lock(target,false);}})();
  },true);
  document.addEventListener('keydown',event=>{if((event.key==='Enter'||event.key===' ')&&event.target.matches('.js-grid-cart,.js-toggle-cart')){event.preventDefault();event.target.click();}});
  document.addEventListener('change',event=>{if(event.target.matches('[data-mood-variant]'))updateVariant(event.target.closest('form'));});
  dialog.querySelectorAll('[data-mood-cart-close]').forEach(el=>el.addEventListener('click',close));
  dialog.addEventListener('cancel',event=>{event.preventDefault();close();});
  dialog.addEventListener('click',event=>{if(event.target===dialog)close();});
  dialog.addEventListener('close',()=>document.body.classList.remove('mood-cart-open'));
  document.addEventListener('cart:refresh',schedule);
  window.addEventListener('pageshow',event=>{if(event.persisted)schedule();});
  document.addEventListener('visibilitychange',()=>{if(!document.hidden)schedule();});
  window.MoodCart={add,refresh,open:()=>{open();refresh().catch(()=>message(words.cart_unavailable,true));}};
  function start(){
    document.body.classList.add('mood-cart-ready');decorate();
    document.querySelectorAll('.mood-buy-form').forEach(updateVariant);
    new MutationObserver(records=>{for(const record of records)for(const added of record.addedNodes)if(added.nodeType===1&&!dialog.contains(added))decorate(added);}).observe(document.body,{childList:true,subtree:true});
    if(window.jQuery)window.jQuery(document).ajaxComplete((event,xhr,settings)=>{if(/\/cart\/(?:add|change|update|clear)(?:\.js)?(?:\?|$)/.test(settings.url||''))schedule();});
    refresh().catch(()=>{});
  }
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',start,{once:true});else start();
})();
  } catch(e) { console.error(e); }
})();

})();
